import schoolphoto5 from '../Assets/Photos/Schoolphoto5.jpeg';
import schoolphoto7 from '../Assets/Photos/Schoolphoto7.jpeg';
import { Tabs } from 'antd';
import '../Styles/main.css'; 

export const items = [
        {
          key: '1',
          label: <span className="tab-label">PlayGroup</span>,
          children: (
            <div className="program-content">
              <img src={schoolphoto5} alt="schoolphoto" className="program-image" />
              <div className="program-text">
                <h5><b>Playgroup (Age: 1.5 - 3 years)</b></h5>
                <p>Our Playgroup program focuses on sensory experiences, social interaction, and early learning in a fun, engaging environment.</p>
                <ul>
                  <li>🎨 Creative play and storytelling</li>
                  <li>🎶 Music, dance, and art activities</li>
                  <li>🔢 Introduction to numbers, shapes, and letters</li>
                  <li>🤝 Social interaction and emotional development</li>
                </ul>
              </div>
            </div>
          ),
        },
        {
          key: '2',
          label: <span className="tab-label">LKG</span>,
          children: (
            <div className="program-content">
              <img src={schoolphoto7} alt="LKG" className="program-image" />
              <div className="program-text">
                <h5><b>LKG (Age: 4 - 5 years)</b></h5>
                <p>Our LKG program enhances foundational skills in literacy, numeracy, and social interaction.</p>
                <ul>
                  <li>📖 Advanced early reading and writing activities</li>
                  <li>🔢 Strengthening basic math concepts</li>
                  <li>🌱 Hands-on exploration of science</li>
                  <li>🎭 Engaging role-playing, storytelling</li>
                </ul>
              </div>
            </div>
          ),
        },
        {
          key: '3',
          label: <span className="tab-label">UKG</span>,
          children: (
            <div className="program-content">
              <img src={schoolphoto5} alt="UKG" className="program-image" />
              <div className="program-text">
                <h5><b>UKG (Age: 5 - 6 years)</b></h5>
                <p>Our UKG program strengthens literacy, numeracy, and critical thinking skills, ensuring a smooth transition to primary school.</p>
                <ul>
                  <li>📖 Advanced reading and writing exercises</li>
                  <li>🔢 Enhanced math concepts and logical reasoning</li>
                  <li>🌍 Exploration of science and environmental studies</li>
                  <li>💡 Problem-solving, creativity, and group activities</li>
                </ul>
              </div>
            </div>
          ),
        },
        {
          key: '4',
          label: <span className="tab-label">First Grade</span>,
          children: (
            <div className="program-content">
              <img src={schoolphoto7} alt="First Grade" className="program-image" />
              <div className="program-text">
                <h5><b>First Grade (Age: 6 - 7 years)</b></h5>
                <p>Our First Grade program builds on foundational skills, fostering independence, critical thinking, and academic excellence.</p>
                <ul>
                  <li>📖 Advanced reading comprehension and writing skills</li>
                  <li>🔢 Introduction to addition, subtraction, and logical reasoning</li>
                  <li>🌍 Basic science and environmental awareness</li>
                  <li>💡 Hands-on learning, problem-solving, and creativity</li>
                  <li>🗣️ Communication skills through discussions and storytelling</li>
                </ul>
              </div>
            </div>
          ),
        },
        {
          key: '5',
          label: <span className="tab-label">Second Grade</span>,
          children: (
            <div className="program-content">
              <img src={schoolphoto7} alt="Second Grade" className="program-image" />
              <div className="program-text">
                <h5><b>Second Grade (Age: 7 - 8 years)</b></h5>
                <p>Our Second Grade program enhances academic skills, critical thinking, and creativity while fostering confidence and independence.</p>
                <ul>
                  <li>📖 Improved reading fluency, vocabulary, and creative writing</li>
                  <li>🔢 Stronger math skills including multiplication, division, and problem-solving</li>
                  <li>🌍 Deeper exploration of science, environment, and social studies</li>
                  <li>💡 Critical thinking through experiments and hands-on projects</li>
                  <li>🗣️ Public speaking, storytelling, and structured communication</li>
                </ul>
              </div>
            </div>
          ),
        },
      ];
export const ProgramsTabs =  () => {
    return <Tabs defaultActiveKey="1" items={items} className="programs-tabs-container-return" />;
  };
  